import {creationTaskToPreviewSingleVoyage} from "@containers/singleVoyage/tasks/helpers/executions";
import React from 'react';
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import MutateTaskMutateSingleVoyageModal
    from "@containers/singleVoyage/mutateVoyage/tasks/MutateTaskMutateSingleVoyageModal";
import Stack from '@mui/material/Stack';
import {
    useDeleteTaskMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/tasks/hooks/useDeleteTaskMutateSingleVoyage";
import DeleteIcon from '@mui/icons-material/Delete';
import ItemTaskInfo from "@containers/singleVoyage/tasks/views/pointTasksInfo/itemTask/ItemTaskInfoViewSingleVoyage";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";

const sx = {
    iconDelete: {
        width: '20px',
        height: '20px',
        transition: 'all .3s',
        '&:hover': {
            cursor: 'pointer'
        }
    },
}

interface IProps {
    task: ITaskCreationSingleVoyageMutateVoyage
    voyageStatus: VoyageStatusSingleVoyage
    accountId: string | number
    currentWaypointId?: number
    number?: number
}


const Actions = ({
                     task,
                 }: IProps) => {

    const {onDelete} = useDeleteTaskMutateSingleVoyage()

    const onDeleteTask = async () => {
        await onDelete({task, voyageId: 0})
    }
    return (
        <Stack
            gap={1}
            direction={'row'}
            alignItems={'center'}
        >
            <MutateTaskMutateSingleVoyageModal
                initial={task}
            />

            <DeleteIcon
                onClick={onDeleteTask}
                sx={sx.iconDelete}
            />
        </Stack>
    )
}

const ItemTaskInfoMutateSingleVoyage = ({
                                            task,
                                            voyageStatus,
                                            accountId,
                                            currentWaypointId,
                                            number,
                                        }: IProps) => {
    return (
        <ItemTaskInfo
            detailed
            task={creationTaskToPreviewSingleVoyage(task)}
            showDescription
            accountId={accountId}
            currentWaypointId={currentWaypointId}
            number={number}
            childrenHeader={
                <Actions
                    task={task}
                    voyageStatus={voyageStatus}
                    accountId={accountId}
                />}
        />
    );
};

export default ItemTaskInfoMutateSingleVoyage;
